/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 *            Olga.Szczepaniak
 */
import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/info-hint.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
var templates = {
    defaultTemplate: template,
};
var _subscriberPrefix = 'component-infohint-';
/**
 * BSSInfohintComponent class
 */
var BSSInfohintComponent = /** @class */ (function (_super) {
    __extends(BSSInfohintComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Object} [toolbox=null]
     * @listens {bss-close-infohints-$ENTITY-INSTANCE-ID} emit event when some component want to close all infohints, eg. on swiper tabs change or on summary template open
     * @listens {bss-start-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     */
    function BSSInfohintComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = this;
        var ihconfig = BSSInfohintComponent.prepareIndependentHintConfig(config, containerSelector);
        _this = _super.call(this, _entityTemplate, containerSelector, ihconfig, eventManager, formatter, resolution, templates, toolbox) || this;
        if ((_this._config.hintTitle || _this._config.hintText) &&
            _this._config.texts) {
            var isOffHintTitle = _this._config.hintTitle
                ? !_this._getBoundedString(_this._config.hintTitle).trim()
                : true;
            var isOffHintText = _this._config.hintText
                ? !_this._getBoundedString(_this._config.hintText).trim()
                : true;
            if (isOffHintTitle && isOffHintText) {
                _this.destroy();
            }
        }
        if (_this._config.texts === undefined) {
            _this.destroy();
        }
        /**
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._hint = _this._entityTemplate.find(_this._componentTemplate.find('#' + _this._config.componentId + '_hint'));
        /**
         * @type {boolean}
         * @private
         */
        _this._isLocaleAphelia = config.isLocaleAphelia;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._triggerBtn = _this._componentTemplate.find('#' + _this._config.componentId + '_hint-btn');
        /**
         * @desc container where qtip tooltip content will be placed
         * @type {jQuery|HTMLElement}
         * parameter used to slide-up-layer-content
         * @private
         */
        _this.findQTipContainer();
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup, if this._entity Template has attribute: is-popup - set this value for this parameter
         */
        _this._isInPopup = _this._entityTemplate.attr('is-popup')
            ? JSON.parse(_this._entityTemplate.attr('is-popup'))
            : _this._toolbox
                .$('[data-toggle="modal"], .modal-body')
                .has('#' + _this._componentScope.attr('id')).length;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global window element
         */
        _this._globalWindow = null;
        /**
         * @type {boolean}
         * @private
         * @desc tor popup
         */
        _this._torPopup = null;
        /**
         * @type {boolean}
         * @private
         * @desc is in widget
         */
        _this._isInWidget = _this._entityTemplate.hasClass('bss-widget-in-widget');
        if (_this._isInPopup) {
            var classNameBody = _this._entityTemplate.attr('data-name-body');
            var classNameContent = _this._entityTemplate.attr('data-name-content');
            if (classNameBody) {
                _this._globalWindow = _this._toolbox.$(classNameBody);
                if (_this._toolbox.$(classNameContent) &&
                    !_this._toolbox.$(classNameContent).hasClass('modal-dialog')) {
                    _this._torPopup = true;
                }
            }
            else {
                _this._globalWindow = _this._toolbox.$('.modal-body');
            }
        }
        else {
            _this._globalWindow = _this._window;
        }
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc slideUpContrainer element
         */
        _this._slideUpContainer = _this._isInPopup
            ? _this._entityTemplate
            : _this._toolbox.$('.bss-slide-up-layer_content');
        _this._addEvents();
        if (!_this._config.initTagging) {
            _this._initializeTaggingInfohint();
        }
        /**
         * stores qtip content object, generated after first
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._qtipContent = _this._entityTemplate.find('#' + _this._config.componentId + '_hint');
        _this._qtipContentClass = _this._entityTemplate.find('.bss-info-hint_content');
        /**
         * @desc container where infohint close
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._closeBtn = _this._entityTemplate.find('#' + _this._config.componentId + '_close');
        _this._triggerBtn.on('click.' + _this._config.componentId, _this._onClick.bind(_this));
        if (!_this._config.debug) {
            var classNameContent = _this._entityTemplate.attr('data-name-content');
            _this._container = _this._toolbox.$(classNameContent);
            var _containerParent = _this._container.parent().parent();
            if (_containerParent.is('dialog') && !_this._isLocaleAphelia) {
                _containerParent.on("click.".concat(_this._config.componentId), _this.hide.bind(_this));
            }
            else {
                _this._htmlBody.on('click.' + _this._config.componentId, _this.hide.bind(_this));
            }
            _this._eventManager.subscribe("bss-close-infohints-".concat(_this._config.entityInstanceId), _this.hide.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        else {
            _this._onClick(new Event('click'));
        }
        return _this;
    }
    Object.defineProperty(BSSInfohintComponent.prototype, "subscriberPrefix", {
        /**
         * @desc getter of _subscriberPrefix (used for recognizing event relation with the components)
         */
        get: function () {
            return _subscriberPrefix;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prepare initial configuration of the info-hint that extends parent's configuration:
     * prevent inheritance of parent specific data as watchers.
     * Static access to be able to modify config before passing it to the parent super
     * @param {Record} config configuration inherited manually from the parent component of info-hint
     * @param {string} containerSelector selector of the container where info-hint component should be appended
     * @return {Record} hintConfig
     */
    BSSInfohintComponent.prepareIndependentHintConfig = function (config, containerSelector) {
        var componentType = config.componentType;
        // Do not use when creating info-hint as standalone component using separated configuration.
        if (componentType === 'InfohintComponent') {
            return config;
        }
        var componentId = config.componentId, containerId = config.containerId, entityInstanceId = config.entityInstanceId, hintText = config.hintText, icon = config.icon, productId = config.productId, resultData = config.resultData, texts = config.texts;
        // for info-hint created within another component using REFERENCE of the parent's configuration
        return {
            componentId: "".concat(componentId, "-infohint"),
            componentType: 'InfohintComponent',
            containerId: containerId,
            containerSelector: containerSelector,
            entityInstanceId: entityInstanceId,
            hintText: hintText,
            icon: icon || '&#xe91a',
            productId: productId,
            resultData: resultData,
            texts: texts,
        };
    };
    BSSInfohintComponent.prototype.findQTipContainer = function () {
        this._qtipContainer = null;
        if (this._config.qtipContainerSelector) {
            this._qtipContainer = this._entityTemplate.find(this._config.qtipContainerSelector);
        }
        else {
            for (var i = 0; i < this._entityTemplate.length; i++) {
                if (this._toolbox
                    .$('#' + this._toolbox.$(this._entityTemplate[i]).attr('id'))
                    .has('#' + this._componentScope.attr('id')).length) {
                    this._qtipContainer = this._toolbox.$(this._entityTemplate[i]);
                }
            }
        }
    };
    /**
     * Add infonit events: to event manager and jQuery elements
     * @private
     */
    BSSInfohintComponent.prototype._addEvents = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _addEvents');
        this._isScrollEventOff = true;
        this._isResizeEventOff = true;
        this._bindScroll();
        this._bindResize();
        this._eventManager.subscribe('bss-start-scroll-for-' + this._config.entityInstanceId, this._bindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-stop-scroll-for-' + this._config.entityInstanceId, this._unbindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-start-resize-for-' + this._config.entityInstanceId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-stop-resize-for-' + this._config.entityInstanceId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
    };
    /**
     * @desc on infohint click actions
     * @param {Event} event event object
     * @private
     */
    BSSInfohintComponent.prototype._onClick = function (event) {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _onClick | Params', event);
        // for onClickKeepOpened config (e.g. for an infohint on a button) hide content first -
        // second click on an infohint when it is opened, will close it and open again (as on swiper tabs)
        // this behaviour prevents buttons switching on a second infohint click
        if (this._config.onClickKeepOpened) {
            this._hideQTip();
        }
        this._onDefaultClick(event);
    };
    /**
     * @desc default show/hide infohint behaviour
     * @param {Event} event object
     * @private
     */
    BSSInfohintComponent.prototype._onDefaultClick = function (event) {
        this._isOpen = this._htmlBody.find('.bss-infohint--is-open');
        for (var i = this._qtipContentClass.length - 1; i >= 0; i--) {
            if (this._isOpen.length ||
                this._qtipContent.hasClass('bss-infohint--is-open')) {
                if (typeof this._isOpen.attr('id') !== 'undefined' &&
                    this._isOpen.attr('id') !== this._qtipContent.attr('id')) {
                    this._show(event);
                }
                this._toolbox
                    .$(this._isOpen[0])
                    .hide()
                    .removeClass('bss-infohint--is-open');
                break;
            }
            else {
                this._show(event);
                event.preventDefault();
                break;
            }
        }
    };
    /**
     * @desc show infohint on click
     * @param event {Object} - event object`
     * @private
     */
    BSSInfohintComponent.prototype._show = function (event) {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _show | Params', event);
        this.findQTipContainer();
        this._qtipContent = this._toolbox.$('.bss-info-hint_content#' + this._config.componentId + '_hint');
        var data;
        data = this._qtipContent[0].outerHTML;
        this._qtipContent.remove();
        this._qtipContainer.append(data);
        this._qtipContent = this._entityTemplate.find('.bss-info-hint_content#' + this._config.componentId + '_hint');
        this._qtipContent.addClass('bss-infohint--is-open');
        setTimeout(this._calculatePosition(), 1500);
        this._closeBtn.on('click.' + this._config.componentId, this.hide.bind(this));
        event.stopPropagation();
    };
    /**
     * @desc calculate position of infohint
     * @private
     */
    BSSInfohintComponent.prototype._calculatePosition = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _calculatePosition');
        if (this._qtipContent.hasClass('bss-info-hint_content--scrollable')) {
            this._qtipContent.removeClass('bss-info-hint_content--scrollable');
        }
        if (this._qtipContent.hasClass('bss-info-hint_content--visible-top')) {
            this._qtipContent.removeClass('bss-info-hint_content--visible-top');
        }
        /**
         * @desc offset left of window
         * @type {Number}
         * @private
         */
        this._windowMarginLeft = null;
        /**
         * @desc offset top of window
         * @type {Number}
         * @private
         */
        this._windowMarginTop = null;
        if (this._isInPopup) {
            var classNameContent = this._entityTemplate.attr('data-name-content');
            var classNameHeader = this._entityTemplate.attr('data-name-header');
            this._container = null;
            this._containerHeader = null;
            if (classNameContent) {
                this._container = this._toolbox.$(classNameContent);
                var _containerParent = this._container.parent().parent();
                if (_containerParent.is('dialog') &&
                    _containerParent.filter('dialog')[0].open === true) {
                    this._container = this._toolbox.$(classNameContent + '.or-modal-content');
                    _containerParent = this._container.parent().parent();
                    this._containerHeader = this._toolbox.$(classNameHeader);
                    var padding = this._isLocaleAphelia === true
                        ? (_containerParent.innerWidth() - _containerParent.width()) / 2 +
                            5
                        : 0;
                    if (_containerParent.offset().left === 0) {
                        this._windowMarginLeft = _containerParent.offset().left + padding;
                    }
                    else if (_containerParent.offset().left <= 100 &&
                        this._isLocaleAphelia === undefined) {
                        this._windowMarginLeft = padding;
                    }
                    else {
                        this._windowMarginLeft = this._container.offset().left;
                    }
                    this._windowMarginTop = this._container.offset().top;
                }
                else {
                    this._containerHeader = this._toolbox.$(classNameHeader);
                    this._windowMarginLeft = this._container.offset().left;
                    this._windowMarginTop = this._container.offset().top;
                }
            }
            else {
                this._container = this._toolbox.$('.modal-dialog');
                this._windowMarginLeft = this._container.offset().left;
                this._windowMarginTop = this._container.offset().top;
            }
        }
        else {
            this._windowMarginLeft = 0;
            this._windowMarginTop = 0;
        }
        /**
         * @desc container for triangle
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._triangle = this._entityTemplate.find('#' + this._config.componentId + '_triangle');
        /**
         * @desc container for text
         * @type {jQuery|HTMLElement}
         * @private
         */
        this._qtipContentText = this._qtipContent.find('.bss-info-hint_text');
        this._qtipContentText.removeAttr('style');
        this._qtipContentTextContent = this._qtipContentText.find('.bss-info-hint_text-content');
        /**
         * @desc height of header
         * @type {Number}
         * @private
         */
        this._headerHeight = this._toolbox.$('.bss-header').outerHeight() || 0;
        /**
         * @desc trigger btn height
         * @type {Number}
         * @private
         */
        this._heightTrigger = this._triggerBtn.outerHeight() || 0;
        /**
         * @desc window scroll
         * @type {Number}
         * @private
         */
        this._windowScroll = this._globalWindow.scrollTop();
        /**
         * @desc trigger btn left position
         * @type {Number}
         * @private
         */
        this._triggerPositionLeft =
            this._triggerBtn[0].getBoundingClientRect().left;
        /**
         * @desc outer width of trigger btn
         * @type {Number}
         * @private
         */
        this._triggerOuterWidth = this._triggerBtn.outerWidth();
        /**
         * @desc entity width
         * @type {Number}
         * @private
         */
        this._entityWidth = this._entityTemplate.width();
        /**
         * @desc infohint width
         * @type {Number}
         * @private
         */
        this._infohintWidth = 290;
        /**
         * @desc position top of infohint tripper
         * @type {Number}
         * @private
         */
        this._positionTopTrigger =
            this._triggerBtn.offset().top - this._toolbox.$(window).scrollTop();
        this._entityTemplate =
            typeof this._entityTemplate === 'undefined'
                ? this._toolbox.$('#simulator')
                : this._entityTemplate;
        this._windowHeight = this._window.outerHeight() || 0;
        if (this._torPopup && this._container) {
            var containerOuterHeight = this._container.outerHeight() || 0;
            var containerHeaderOuterHeight = this._containerHeader.outerHeight() || 0;
            this._globalWindowHeight =
                containerOuterHeight - containerHeaderOuterHeight;
        }
        else {
            this._globalWindowHeight = this._globalWindow.outerHeight() || 0;
        }
        this._globalWindowTop = this._isInPopup
            ? this._globalWindow.offset()
                ? this._globalWindow.offset().top - this._window.scrollTop()
                : 0
            : 0;
        this._globalWindowBottom =
            this._windowHeight - this._globalWindowTop - this._globalWindowHeight;
        this._qtipContentMaxHeight =
            this._globalWindowHeight +
                this._globalWindowTop -
                this._positionTopTrigger -
                (this._triggerBtn.outerHeight() || 0);
        this._qtipContentBottom =
            this._globalWindowHeight +
                this._globalWindowTop -
                this._positionTopTrigger -
                (this._triggerBtn.outerHeight() || 0) -
                30; // 15px its height of triangle and little space of infohint and 15px its space that isn't too close bottom
        if (this._entityTemplate.hasClass('iPhone')) {
            this._qtipContentBottom -= 50; // bottom bar on iPhone
        }
        var heightTop = this._positionTopTrigger - this._globalWindowTop;
        var heightBottom = this._windowHeight - this._globalWindowBottom - this._positionTopTrigger;
        var top = null;
        var bottom = null;
        var left = this._calculateLeft();
        this._calculateTrianglePosition();
        if (this._isInPopup) {
            this._qtipContent.css({
                visibility: 'hidden',
            });
        }
        this._qtipContent.css({
            display: 'block',
            'z-index': '10000',
            opacity: '1',
            position: 'fixed',
            left: left + 'px',
            width: this._infohintWidth + 'px',
        });
        var bottomArtifact = 80;
        this._qtipContentHeight = this._qtipContentTextContent.outerHeight() || 0;
        if (this._qtipContentHeight < this._qtipContentBottom) {
            top = this._calculateTop();
        }
        else if (this._qtipContentHeight >= this._qtipContentBottom) {
            if (heightTop > heightBottom - 10) {
                this._qtipContent.addClass('bss-info-hint_content--visible-top');
                bottom = this._calculateBottom();
                var qtipContentMaxHeightBottom = this._positionTopTrigger - this._globalWindowTop;
                if (this._qtipContentHeight >= qtipContentMaxHeightBottom) {
                    this._qtipContent.addClass('bss-info-hint_content--scrollable');
                    qtipContentMaxHeightBottom =
                        qtipContentMaxHeightBottom - bottomArtifact;
                    if (this._entityTemplate.hasClass('iPhone')) {
                        qtipContentMaxHeightBottom -= 50; // bottom bar on iPhone
                    }
                    this._qtipContentText.css({
                        height: qtipContentMaxHeightBottom + 'px',
                    });
                }
            }
            else {
                top = this._calculateTop();
                this._qtipContent.addClass('bss-info-hint_content--scrollable');
                this._qtipContentMaxHeight =
                    this._qtipContentMaxHeight - bottomArtifact;
                this._qtipContentText.css({
                    height: this._qtipContentMaxHeight + 'px',
                });
            }
        }
        if (top) {
            this._qtipContent.css({
                top: top + 'px',
                bottom: 'auto',
            });
        }
        else {
            this._qtipContent.css({
                top: 'auto',
                bottom: bottom + 'px',
            });
        }
        if (this._isInPopup) {
            if (this._torPopup) {
                var dist = this._qtipContent.offset().top -
                    this._triggerBtn.offset().top -
                    (this._triggerBtn.outerHeight() || 0);
                var adjustDist = void 0;
                if (dist > 20) {
                    adjustDist = dist - 20;
                    if (top) {
                        this._qtipContent.css({
                            top: top - adjustDist + 'px',
                        });
                    }
                }
            }
            this._qtipContent.css({
                visibility: 'visible',
            });
        }
    };
    /**
     * @desc updates infohint value from the result data
     * @private
     */
    BSSInfohintComponent.prototype.update = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _update');
        if (this._config.hintText &&
            this._config.hintText.indexOf('data-value') !== -1) {
            this._componentScope
                .find('.bss-info-hint_text-content value')
                .text(this._getBoundedString(this._config.hintText));
        }
    };
    /**
     * @desc calculate top position of infohint
     * @private
     */
    BSSInfohintComponent.prototype._calculateTop = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _calculateTop');
        var top;
        if (this._isInPopup) {
            top = this._positionTopTrigger + 5;
            if (this._torPopup) {
                top += 5;
            }
            var _containerParent = this._container.parent().parent();
            if ((this._isLocaleAphelia === true || _containerParent.is('dialog')) &&
                this._resolution.getCurrent() !== 'xs' &&
                _containerParent.scrollTop() > 0) {
                top = top + (this._windowMarginTop + _containerParent.scrollTop() - 27);
            }
            else if (this._resolution.getCurrent() === 'xs') {
                top += 27 - this._windowMarginTop + this._window.scrollTop();
                if (this._container &&
                    this._container.css('transform') &&
                    this._container.css('transform') === 'none') {
                    top += parseFloat(this._container.offset().top);
                }
            }
            else if (this._container &&
                this._container.css('transform') &&
                this._container.css('transform') === 'none') {
                top +=
                    this._windowMarginTop -
                        this._window.scrollTop() +
                        parseFloat(this._container.css('margin-top'));
            }
        }
        else {
            top = this._positionTopTrigger + 15 + this._heightTrigger;
        }
        return top;
    };
    /**
     * @desc calculate bottom position of infohint
     * @private
     */
    BSSInfohintComponent.prototype._calculateBottom = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _calculateBottom');
        var bottom;
        if (this._isInPopup) {
            bottom =
                this._qtipContentMaxHeight + (this._triggerBtn.outerHeight() || 0) + 15; // 15px its height of triangle and little space of infohint
            if (this._container &&
                this._container.css('transform') &&
                this._container.css('transform') === 'none') {
                bottom += this._globalWindowBottom;
            }
        }
        else {
            bottom =
                this._windowHeight - this._positionTopTrigger + this._heightTrigger;
        }
        return bottom;
    };
    /**
     * @desc calculate left position of infohint
     * @private
     */
    BSSInfohintComponent.prototype._calculateLeft = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _calculateLeft');
        var left;
        var leftInfohintClass = 'bss-infohint--left';
        var middleInfohintClass = 'bss-infohint--middle';
        this._qtipContent.removeClass(leftInfohintClass);
        this._qtipContent.removeClass(middleInfohintClass);
        if (this._triggerPositionLeft +
            this._infohintWidth -
            this._windowMarginLeft <=
            this._entityWidth - 30) {
            left = this._triggerPositionLeft - 5 - this._windowMarginLeft;
        }
        else if (this._triggerPositionLeft - this._infohintWidth < 15) {
            // On xs view use middle infohint position
            var isInfohintOnTab = this._config.componentId.indexOf('navigationTabs') !== -1 &&
                !this._isInPopup;
            left = isInfohintOnTab ? 15 : 50;
            this._qtipContent.addClass(middleInfohintClass);
        }
        else {
            // On sm< view use left infohint position
            left =
                this._triggerPositionLeft +
                    5 -
                    this._windowMarginLeft -
                    this._infohintWidth +
                    this._triggerOuterWidth;
            this._qtipContent.addClass(leftInfohintClass);
        }
        if (this._isInPopup) {
            if (this._resolution.getCurrent() !== 'xs' &&
                this._container &&
                this._container.css('transform') &&
                this._container.css('transform') === 'none') {
                left += this._windowMarginLeft;
            }
        }
        return left;
    };
    /**
     * @desc calculate triangle position of infohint
     * @private
     */
    BSSInfohintComponent.prototype._calculateTrianglePosition = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _calculateTrianglePosition');
        var trianglePosition;
        if (this._triggerPositionLeft -
            this._windowMarginLeft +
            this._infohintWidth <=
            this._entityWidth - 30) {
            trianglePosition = 5;
            this._triangle.css({
                left: trianglePosition + 'px',
            });
        }
        else if (this._triggerPositionLeft - this._windowMarginLeft - this._infohintWidth <
            30) {
            trianglePosition =
                this._triggerPositionLeft -
                    parseInt(this._triangle.css('border-left-width')) -
                    parseInt(this._triangle.css('border-left-width'));
            if (this._isInPopup || this._isInWidget) {
                trianglePosition =
                    this._triggerPositionLeft -
                        this._windowMarginLeft -
                        50 -
                        (parseInt(this._triangle.css('border-left-width')) * 2 -
                            this._triggerOuterWidth) /
                            2;
            }
            else {
                if (this._resolution.getCurrent() === 'xs') {
                    if (this._config.componentId.indexOf('navigationTabs') !== -1) {
                        trianglePosition += 3;
                    }
                    else {
                        trianglePosition -= this._triggerOuterWidth + 5;
                    }
                }
                else {
                    trianglePosition -= this._triggerOuterWidth / 2 + 6;
                }
            }
            this._triangle.css({
                left: trianglePosition + 'px',
                right: 'auto',
            });
        }
        else {
            trianglePosition = 7;
            this._triangle.css({
                left: 'auto',
                right: trianglePosition + 'px',
            });
        }
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSInfohintComponent.prototype._bindScroll = function () {
        var _a, _b;
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _bindScroll');
        if (this._isScrollEventOff) {
            var apheliaDialog = this._globalWindow
                .filter('.bss-modal-popup')
                .parent()
                .parent()
                .parent();
            if (((_a = apheliaDialog[0]) === null || _a === void 0 ? void 0 : _a.open) === true) {
                apheliaDialog.on('scroll.' + this._config.componentId, this._onScroll.bind(this));
            }
            else {
                this._globalWindow.on('scroll.' + this._config.componentId, this._onScroll.bind(this));
                if (this._globalWindow && ((_b = this._globalWindow) === null || _b === void 0 ? void 0 : _b.children().length) >= 2)
                    this._toolbox
                        .$(this._globalWindow.children()[1])
                        .on('scroll.' + this._config.componentId, this._onScroll.bind(this));
            }
            if (!this._isInPopup) {
                this._slideUpContainer.on('scroll.' + this._config.componentId, this._onScroll.bind(this));
            }
            this._isScrollEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSInfohintComponent.prototype._unbindScroll = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _unbindScroll');
        this._globalWindow.off('scroll.' + this._config.componentId);
        this._isScrollEventOff = true;
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSInfohintComponent.prototype._bindResize = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._onResize.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSInfohintComponent.prototype._unbindResize = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc initialize tagging - for radiotabs component that have infohint component initializeTagging should be empty
     * @private
     * @override
     */
    BSSInfohintComponent.prototype._initializeTagging = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _initializeTagging');
    };
    /**
     * @desc actual _initializeTagging
     * @private
     */
    BSSInfohintComponent.prototype._initializeTaggingInfohint = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _initializeTaggingInfohint');
        _super.prototype._initializeTagging.call(this);
    };
    /**
     * @desc callback on scroll, tooltips are hidden on scroll
     * @private
     */
    BSSInfohintComponent.prototype._onScroll = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _onScroll');
        this._hideQTip();
    };
    /**
     * @desc callback on window resize, hide tooltip
     * @private
     */
    BSSInfohintComponent.prototype._onResize = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _onResize');
        this._hideQTip();
    };
    /**
     * @desc hide tooltip
     * @private
     */
    BSSInfohintComponent.prototype._hideQTip = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _hideQTip');
        if (typeof this._triggerBtn) {
            this._qtipContent.removeClass('bss-infohint--is-open');
            this._qtipContent.hide();
        }
    };
    /**
     * @desc Destroys qTip and calls super method
     * @public method
     */
    BSSInfohintComponent.prototype.destroy = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        _super.prototype.destroy.call(this);
    };
    /**
     *
     * @desc clears tag value and qtip content before update, needed because some data can be removed from resultData/texts and after update they should be empty
     * @param updateMap {Object) - whole object for update data
     * @private
     * @override
     */
    BSSInfohintComponent.prototype._resetValueTags = function (updateMap) {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _resetValueTags | Params', updateMap);
        var valueTags;
        var tipTags;
        var productIDs = [];
        var selectorTab = [];
        var selectorString;
        if (this._toolbox._.has(updateMap, 'texts')) {
            //we add product ids from texts
            productIDs = this._toolbox._.keys(updateMap.texts);
            for (var i = 0, len = productIDs.length; i < len; i++) {
                selectorTab.push('value[data-text^="' + productIDs[i] + '"]');
            }
        }
        productIDs = this._toolbox._.keys(updateMap.resultData);
        for (var i = 0, len = productIDs.length; i < len; i++) {
            selectorTab.push('value[data-value^="' + productIDs[i] + '"]');
        }
        selectorString = this._toolbox._.join(selectorTab, ',');
        valueTags = this._toolbox.$(this._componentScope.find(selectorString));
        tipTags = this._toolbox.$(this._qtipContent.find(selectorString));
        valueTags.text('');
        tipTags.text('');
    };
    /**
     *
     * @desc rebinds data given as only refreshed records, method updates data in qtip content which is outside component template
     * @override
     * @param {Object} [bindValuesObj=null]
     * @param {string} [dataType=null] - type of data, 'texts' || 'resultData'
     */
    BSSInfohintComponent.prototype._rebindData = function (bindValuesObj, dataType) {
        if (bindValuesObj === void 0) { bindValuesObj = null; }
        if (dataType === void 0) { dataType = null; }
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _rebindData' +
            ' | Params: ', bindValuesObj, dataType);
        var valuesSelector;
        var bindData;
        var inc = 0;
        if (dataType === null && typeof bindValuesObj.texts !== 'undefined') {
            valuesSelector = 'text';
            bindData = bindValuesObj.texts;
        }
        else {
            valuesSelector = 'value';
            bindData = bindValuesObj.resultData;
        }
        for (var prod in bindData) {
            for (var prodItem in bindData[prod]) {
                var values = this._toolbox.$(this._componentScope.find('[data-' + valuesSelector + '="' + prod + '.' + prodItem + '"]'));
                var qtipValues = this._toolbox.$(this._qtipContent.find('[data-' + valuesSelector + '="' + prod + '.' + prodItem + '"]'));
                if (inc === 0) {
                    var currentProductValues = this._toolbox.$(this._componentScope.find('[data-' +
                        valuesSelector +
                        '="$productId$' +
                        '.' +
                        prodItem +
                        '"]'));
                    if (currentProductValues.length > 0) {
                        values = values.add(currentProductValues);
                    }
                }
                this._bindValues(bindData, qtipValues, prod, valuesSelector);
                this._bindValues(bindData, values, prod, valuesSelector);
            }
            inc++;
        }
        if (valuesSelector === 'text') {
            this._rebindData(bindValuesObj, 'value');
        }
    };
    /**
     * @desc method hides tip
     * @param event {Object} - event object
     * @public
     */
    BSSInfohintComponent.prototype.hide = function (event) {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : hide | Params', event);
        if (event &&
            event.target &&
            this._toolbox.$(event.target)[0].className !== 'bss-info-hint-close' &&
            ((this._toolbox.$(event.target).parent().length &&
                typeof this._toolbox.$(event.target).parent()[0].className !==
                    'undefined' &&
                this._toolbox.$(event.target)[0].className === '' &&
                this._toolbox.$(event.target).parent()[0].className.indexOf &&
                this._toolbox
                    .$(event.target)
                    .parent()[0]
                    .className.indexOf('bss-info-hint') !== -1) ||
                (this._toolbox.$(event.target)[0].className.indexOf &&
                    this._toolbox
                        .$(event.target)[0]
                        .className.indexOf('bss-info-hint') !== -1))) {
            return false;
        }
        if (typeof this._triggerBtn !== 'undefined') {
            this._qtipContent.removeClass('bss-infohint--is-open');
            this._qtipContent.hide();
        }
    };
    return BSSInfohintComponent;
}(BSSAbstractComponent));
export default BSSInfohintComponent;
